import React, {useState} from 'react'
import {connect} from 'react-redux'
import {userActions} from '../../actions'
import {Formik, Form} from 'formik'
import {makeStyles} from '@material-ui/core/styles'
import {Visibility, VisibilityOff} from '@material-ui/icons'
import {
    Box,
    Button,
    TextField,
    IconButton,
    InputAdornment,
    CircularProgress,
} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    form: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    iconButton: {
        padding: 0,
        '&:hover': {
            backgroundColor: theme.palette.grey.pale,
        },
    },
    icon: {
        height: '1.5rem',
        width: '1.5rem',
    },
    closeButton: {
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            borderColor: theme.palette.error.light,
        },
    },
    errorMsg: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: theme.palette.error.light,
        borderRadius: theme.shape.borderRadius,
        borderLeftColor: theme.palette.error.contrastText,
        borderLeftStyle: 'solid',
        borderLeftWidth: '0.3125rem',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(3, 0, 2),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        '&:hover': {
            boxShadow: 'none',
            color: theme.palette.common.white,
            backgroundColor: theme.palette.green.dark,
        },
    },
}))

const LoginForm = props => {
    const classes = useStyles()
    const {login, isLoading} = props
    const [showPassword, setshowPassword] = useState(false)

    const handleClickShowPassword = () => {
        setshowPassword(!showPassword)
    }

    return (
        <>
            {isLoading ? (
                <div align="center" style={{margin: '50%'}}>
                    <CircularProgress
                        style={{
                            color: '#00853e',
                        }}
                        thickness={3}
                    />
                </div>
            ) : (
                <Box>
                    <Formik
                        initialValues={{username: '', password: ''}}
                        onSubmit={async values => {
                            login(values)
                        }}
                    >
                        {props => (
                            <Form
                                onSubmit={props.handleSubmit}
                                className={classes.form}
                            >
                                <TextField
                                    id="euid"
                                    name="username"
                                    label="EUID"
                                    fullWidth
                                    autoComplete="off"
                                    margin="normal"
                                    variant="filled"
                                    value={props.values.username}
                                    onBlur={props.handleBlur}
                                    onChange={props.handleChange}
                                />

                                <TextField
                                    id="password"
                                    name="password"
                                    label="Password"
                                    fullWidth
                                    autoComplete="off"
                                    margin="normal"
                                    variant="filled"
                                    type={showPassword ? 'text' : 'password'}
                                    value={props.values.password}
                                    onBlur={props.handleBlur}
                                    onChange={props.handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    className={
                                                        classes.iconButton
                                                    }
                                                    aria-label="toggle password visibility"
                                                    onClick={
                                                        handleClickShowPassword
                                                    }
                                                >
                                                    {showPassword ? (
                                                        <Visibility
                                                            className={
                                                                classes.icon
                                                            }
                                                        />
                                                    ) : (
                                                        <VisibilityOff
                                                            className={
                                                                classes.icon
                                                            }
                                                        />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                                <Button
                                    className={classes.submitButton}
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    margin="normal"
                                    disabled={
                                        !props.dirty || props.isSubmitting
                                    }
                                >
                                    login
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Box>
            )}
        </>
    )
}

function mapStateToProps(state) {
    return {
        isLoading: state.authentication.loggingIn,
    }
}

const mapDispatchToProps = {
    login: credentials => userActions.login(credentials),
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
